export const openNewTabUrl = (newUrl: string) => {
    window.open(newUrl, '_blank');
}